@if (features.devices?.swapped) {
  <div class="bg-white border m-2 pt-3 px-3 d-flex flex-column shadow-sm">
    <div class="border-bottom pb-1">
      <strong class="text-primary">Swapped</strong>
    </div>
    <div>
      <p>
        This device has been swapped and therefore is in lost mode and needs to be re-enabled as <b>spare</b>
        before it can be used again. If the device is really lost, mark it as unavailable.
      </p>
    </div>
    <era-device-swapped-current-action-bar></era-device-swapped-current-action-bar>
  </div>
}